export class UnTransferLeadsInput {
  leadIds: string[];
  comments?: string;

  constructor(leadIds: any) {
    this.leadIds = leadIds;
  }
}
